function hoverplay() {
  let videos = document.querySelectorAll("video");
  videos.forEach((video) => {
      // We can only control playback without insteraction if video is mute
      video.muted = true;
      // Play is a promise so we need to check we have it
      let playPromise = video.play();
      if (playPromise !== undefined) {
          playPromise.then((_) => {
              let observer = new IntersectionObserver(
                  (entries) => {
                      entries.forEach((entry) => {
                          if (
                              entry.intersectionRatio !== 1 &&
                              !video.paused
                          ) {
                              video.pause();
                          } else if (video.paused) {
                              video.play();
                          }
                      });
                  },
                  { threshold: 0.5 }
              );
              observer.observe(video);
          });
      }
  });
}

  export default {
    init: function () {
      hoverplay();
    }
  };
  


  // function hoverplay() {
  //   window.onload = function() {
  //     const items = document.querySelectorAll('.card_inner');

  //     items.forEach(item => {
  //       // see change below
  //       const video = item.querySelector('video');
      
  //       item.addEventListener('mouseover', function() {
  //         video.play();
  //       });
      
  //       item.addEventListener('mouseout', function() {
  //         video.pause();
  //         video.currentTime = 0;
  //       });
  //     });
  //    }
  // }
  // export default {
  //   init: function () {
  //       hoverplay();
  //   }
  // };
  

  